<script>
import Thumbnail from 'dashboard/components/widgets/Thumbnail.vue';
import MultiselectDropdownItems from 'shared/components/ui/MultiselectDropdownItems.vue';
export default {
  components: {
    Thumbnail,
    MultiselectDropdownItems,
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    selectedItem: {
      type: Object,
      default: () => ({}),
    },
    hasThumbnail: {
      type: Boolean,
      default: true,
    },
    multiselectorTitle: {
      type: String,
      default: '',
    },
    // Sem default cravado em ingles -- ver a nota em MultiselectDropdownItems.
    // Prop default no Vue 2 nao alcanca o `$t`, entao o vazio entra como
    // sentinela e a traducao vem do computed. `inputPlaceholder` e
    // `noSearchResult` descem para o filho como estao: vazios la, ele aplica o
    // proprio fallback, e nao ha traducao duplicada.
    multiselectorPlaceholder: {
      type: String,
      default: '',
    },
    noSearchResult: {
      type: String,
      default: '',
    },
    inputPlaceholder: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showSearchDropdown: false,
    };
  },
  computed: {
    placeholderSemSelecao() {
      return (
        this.multiselectorPlaceholder ||
        this.$t('GENERAL.MULTISELECT_DROPDOWN.NONE')
      );
    },
    hasValue() {
      if (this.selectedItem && this.selectedItem.id) {
        return true;
      }
      return false;
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) {
        return;
      }
      this.showSearchDropdown = !this.showSearchDropdown;
    },

    onCloseDropdown() {
      this.showSearchDropdown = false;
    },

    onClickSelectItem(value) {
      this.$emit('click', value);
      this.onCloseDropdown();
    },
  },
};
</script>

<template>
  <div
    v-on-clickaway="onCloseDropdown"
    class="relative w-full mb-2"
    @keyup.esc="onCloseDropdown"
  >
    <woot-button
      variant="hollow"
      color-scheme="secondary"
      class="w-full border border-solid border-line-faint/50 px-2 hover:border-line-faint focus-visible:ring-2 focus-visible:ring-primary-400 dark:focus-visible:ring-primary-500"
      :is-disabled="disabled"
      @click="toggleDropdown"
    >
      <div class="flex gap-1">
        <Thumbnail
          v-if="hasValue && hasThumbnail"
          :src="selectedItem.thumbnail"
          size="24px"
          :status="selectedItem.availability_status"
          :username="selectedItem.name"
        />
        <div class="flex justify-between w-full min-w-0 items-center">
          <h4 v-if="!hasValue" class="text-ellipsis text-sm text-body">
            {{ placeholderSemSelecao }}
          </h4>
          <h4
            v-else
            class="items-center leading-tight overflow-hidden whitespace-nowrap text-ellipsis text-sm text-body"
            :title="selectedItem.name"
          >
            {{ selectedItem.name }}
          </h4>
          <i
            v-if="showSearchDropdown"
            class="icon ion-chevron-up text-slate-600 mr-1"
          />
          <i v-else class="icon ion-chevron-down text-slate-600 mr-1" />
        </div>
      </div>
    </woot-button>
    <div
      :class="{ 'dropdown-pane--open': showSearchDropdown }"
      class="dropdown-pane !shadow-lg !bg-surface dark:!bg-surface ! !ring-1 !ring-slate-100 dark:!ring-slate-800/50"
    >
      <div class="flex justify-between items-center mb-1">
        <h4
          class="text-sm text-body m-0 overflow-hidden whitespace-nowrap text-ellipsis"
        >
          {{ multiselectorTitle }}
        </h4>
        <woot-button
          icon="dismiss"
          size="tiny"
          color-scheme="secondary"
          variant="clear"
          @click="onCloseDropdown"
        />
      </div>
      <MultiselectDropdownItems
        v-if="showSearchDropdown"
        :options="options"
        :selected-items="[selectedItem]"
        :has-thumbnail="hasThumbnail"
        :input-placeholder="inputPlaceholder"
        :no-search-result="noSearchResult"
        @click="onClickSelectItem"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.dropdown-pane {
  @apply box-border top-[2.625rem] w-full;
}
</style>
